import { ReactionBarController } from './reaction-bar.controller'

function reactionBar () {
  return {
    restrict: 'E',
    scope: {
      post: '=',
      config: '<',
      readersData: '=',
      usersRead: '<'
    },
    templateUrl: '/posts/directives/reaction-bar/reaction-bar-directive.html?$$REVISION$$',
    controller: ReactionBarController
  }
}

export { reactionBar }
